export default __webpack_public_path__ + "static/media/swap.daf90ec6.svg";